<template>
    <div class="search_1">
        <div class="item" @click="selectAnnounce(1)" v-if="!nodata">
            <h2>天王表新款、母亲节陈列管理文件</h2>
            <p>2017.12.11</p>
            <span class="sign"></span>
        </div>
        <div class="noData" v-if="nodata">
            <img src="../../assets/49@2x.png" alt>
            <p class="no_content">没有公告/文件</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            nodata: false
        }
    },
    created(){
        this.$root.center.$on("change_min_tab", data => {
            if (data == 0) {
                this.nodata = false;
            } else {
                this.nodata = true;
            }
        });
    },
    methods:{
        selectAnnounce(index){
            this.$router.push({
                path: '/announcementDetail',
                query: {
                    id: index
                }
            })
        }
    }
}
</script>

<style scoped>
.search_1{
    width: 100%;
    height: 100%;
    padding: 15px;
}
.item{
    width: 100%;
    position: relative;
    background:#ffffff;
    box-shadow:0 5px 20px 5px rgba(227,232,235,0.75);
    border-radius:8px;
    height:88px;
    padding: 20px 15px;
    margin-bottom: 15px;
}
.item:last-child{
    margin-bottom: 0;
}
.item h2{
    font-family:PingFangSC-Medium;
    font-size:18px;
    line-height: 28px;
    color:#414352;
    letter-spacing:0;
    text-align:left;
}
.item p {
    font-family:PingFangSC-Regular;
    font-size:12px;
    color:#a0a0a0;
    letter-spacing:0;
    text-align:left;
}
.item .sign{
    position: absolute;
    top: 25px;
    right: 16px;
    display: inline-block;
    background:#e34f23;
    width:8px;
    height:8px;
    border-radius:100%;
}
.noData {
  width: 100%;
  height: 100%;
  padding-top: 20%;
}
.noData > img {
  display: block;
  margin: auto;
  width: 200px;
}
.noData .no_content {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #a0a0a0;
  letter-spacing: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/search_item/administration_search2.vue